import { z } from 'zod';
export const fieldErasureSchema = z.strictObject({
    id: z.uuid(),
    status: z.enum(['pending', 'running', 'retry', 'complete']),
    attempts: z.number().int().nonnegative(),
    verifiedAt: z.iso.datetime().nullable(),
});
export const fieldErasureStatusSchema = z.strictObject({ erasure: fieldErasureSchema.nullable() });
export const fieldErasureRequestSchema = z.strictObject({
    reason: z.enum(['learner_request', 'admin_request']),
});
